import { httpInterceptor } from '../http-interceptor';

export class VendorService {
  static ENDPOINTS = {
    GET_ALL: 'vendor/getallvendors',
    CREATE: 'vendor/savevendor',
    UPDATE: 'vendor/updatevendor',
    DELETE: 'vendor/deletevendor',
    GET_BY_ID: 'vendor/getvendorbyid',
  };

  static async getAllVendorsList(data) {
    try {
      const response = await httpInterceptor.post(this.ENDPOINTS.GET_ALL, data);
      return response;
    } catch (error) {
      console.error('VendorService.getAllVendorsList - error:', error);
      throw error;
    }
  }

  static async getVendorById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
  }

  static async createVendor(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, data);
  }

  static async updateVendor(id, data) {
    return httpInterceptor.put(`${this.ENDPOINTS.UPDATE}/${id}`, data);
  }

  static async deleteVendor(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }
} 